export default {
  getPrestadorId: state => state.idRnpPrestador,
  getTipoQuestionario: state => state.tipoQuestionario,
  getIsFetched: state => state.isFetched,
  getPullComp: state => state.pullComplexidades,
  getPayloadComplexidades: state => state.payloadComplexidades,
  getComboComplexidades: state => state.comboComplexidades,
  getPayloadServidor: state => campo => {
    if (!state.payloadServidor) return null;
    if (Object.keys(state.payloadServidor).length === 0) return null;

    if (campo) {
      if (!state.payloadServidor[campo]) return null;
      if (state.payloadServidor[campo].length == 0) return null;
      return state.payloadServidor[campo];
    } else {
      return state.payloadServidor;
    }
  }
};
